<template>
  <div class="mobile:mx-3 mobile:mb-6">
    <KikHeading
      v-if="topTitle"
      :title="topTitle"
      class="my-4 inline-block"
    />
    <KikCarousel>
      <div
        v-for="(category, i) in topCategories"
        :key="i"
        class="shrink-0 cursor-pointer rounded-md first:ms-auto last:me-auto"
      >
        <TopItem
          :title="category.title"
          :subtitle="category.subtitle"
          :image="category.src"
          :src-set="category.srcSet"
          :cta-link="category.ctaLink"
          :slug="category.slug"
          :link-target-mode="category.linkTargetMode"
          :alt="category.alt"
        />
      </div>
    </KikCarousel>
  </div>
</template>

<script lang="ts" setup>
import TopItem from './TopItem.vue';
import magnoliaGetters from '~/composables/getters/magnoliaGetters';
import categoryBreadCrumbs, { type CategoryBreadCrumbs } from '~/helpers/utils/categoryBreadCrumbs';

interface Props {
  topTitle?: string;
  topTitleColor?: string;
  slides?: any[];
}

const props = withDefaults(defineProps<Props>(), {
  topTitleColor: '',
  slides: () => [],
});

const slides = toRef(props, 'slides');
const { $domain } = useNuxtApp();
const { result: categories } = useCategories();

const categorySlug = (slide) => {
  if (!slide?.category[0]) {
    return '';
  }

  const categoryData = JSON.parse(slide.category[0]);

  if (!categoryData) {
    return '';
  }

  const categoryPaths: CategoryBreadCrumbs[] = categoryBreadCrumbs(categories.value, 'id', categoryData.categoryId) ?? [];

  if (!categoryPaths.length) {
    return '';
  }

  const slugArr = [categoryPaths[0].slug];
  if (categoryPaths?.length > 1) {
    slugArr.push(categoryPaths[categoryPaths.length - 1].slug);
  }

  return slugArr.join('/');
};

const topCategories = computed(() => slides.value?.map(slide => ({
  title: slide.title,
  subtitle: slide.subTitle,
  src: magnoliaGetters.getDefaultSrcAsset(slide.image, $domain.cmsAssetDomainPath),
  srcSet: magnoliaGetters.getSrcSetImages(slide.image, $domain.cmsAssetDomainPath, slide.aspectRatio, slide.mobileAspectRatio?.[0]?.aspectRatio),
  ctaLink: slide.ctaLink?.[0] ? magnoliaGetters.getLinkAndName(slide.ctaLink[0], $domain.cmsAssetDomainPath, slide.ctaLink[0].switchable?.intLinkParam) : {},
  slug: categorySlug(slide),
  linkTargetMode: slide.linkTargetMode,
  alt: slide.alt,
})));
</script>
